
/*!
* Copyright (c) Microsoft Corporation.
* All rights reserved. See LICENSE in the project root for license information.
* THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
* TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
*/
// tslint:disable
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './DataServiceEntities.g';


function isAliveQuery(): DataServiceQuery {
  return new DataServiceQuery();
}


export function isAliveInput(

): IDataServiceRequest {
  const query = isAliveQuery();
  return query.createDataServiceRequestForOperation(
    'IsAlive',
    false,
    ''
    ,
    'false',
    { bypassCache: 'get', returnEntity: '' },
    {

    }
  );
}

export function isAliveAsync(
  context: IContext
): AsyncResult<boolean> {
  const request = isAliveInput();
  return callActionOrExecute<boolean>(request, context.callerContext);
}

function isAliveOUNQuery(): DataServiceQuery {
  return new DataServiceQuery();
}


export function isAliveOUNInput(
  operatingOrgUnitNumber:
    string
): IDataServiceRequest {
  const query = isAliveOUNQuery();
  return query.createDataServiceRequestForOperation(
    'IsAliveOUN',
    false,
    ''
    ,
    'false',
    { bypassCache: 'get', returnEntity: '' },
    {
      operatingOrgUnitNumber: operatingOrgUnitNumber
    }
  );
}

export function isAliveOUNAsync(
  context: IContext, operatingOrgUnitNumber:
    string
): AsyncResult<boolean> {
  const request = isAliveOUNInput(operatingOrgUnitNumber);
  return callActionOrExecute<boolean>(request, context.callerContext);
}


// @ts-ignore
function shippingQuery(id?: string): DataServiceQuery {
  const key = (id) ? { Id: id } : null;
  return new DataServiceQuery("Shipping", "CustomResponseEntity_1OfIEnumerable_1OfShippingOptionEntity", DataServiceEntities.CustomResponseEntity_1OfIEnumerable_1OfShippingOptionEntityExtensionClass, key);
}


export function createTestItInput(shippingOptionEntityTestTemp: DataServiceEntities.IShippingOptionEntityTestTemp): IDataServiceRequest {
  const query = shippingQuery();
  return query.createDataServiceRequestForOperation('TestIt', true, '', 'false', { bypassCache: 'get', returnEntity: '' }, { shippingOptionEntityTestTemp: shippingOptionEntityTestTemp });
}


export function testItAsync(context: IContext, shippingOptionEntityTestTemp: DataServiceEntities.IShippingOptionEntityTestTemp): AsyncResult<string> {
  const request = createTestItInput(shippingOptionEntityTestTemp);
  return callActionOrExecute<string>(request, context.callerContext);
}

export function createShippingOptionsInput(cartId: string): IDataServiceRequest {
  const query = shippingQuery();
  return query.createDataServiceRequestForOperation('ShippingOptions', false, DataServiceEntities.CustomResponseEntity_1OfList_1OfShippingOptionEntityExtensionClass, 'false', { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICustomResponseEntity_1OfList_1OfShippingOptionEntity' }, { cartId: cartId });
}


export function shippingOptionsAsync(context: IContext, cartId: string): AsyncResult<DataServiceEntities.ICustomResponseEntity_1OfList_1OfShippingOptionEntity> {
  const request = createShippingOptionsInput(cartId);
  return callActionOrExecute<DataServiceEntities.ICustomResponseEntity_1OfList_1OfShippingOptionEntity>(request, context.callerContext);
}

export function createGetErrorCodesInput(): IDataServiceRequest {
  const query = shippingQuery();
  return query.createDataServiceRequestForOperation('GetErrorCodes', false, '', 'false', { bypassCache: 'none', returnEntity: '' }, {});
}


export function getErrorCodesAsync(context: IContext): AsyncResult<string> {
  const request = createGetErrorCodesInput();
  return callActionOrExecute<string>(request, context.callerContext);
}


// @ts-ignore
function sASQuery(id?: number): DataServiceQuery {
  const key = (id) ? { Id: id } : null;
  return new DataServiceQuery("SAS", "SASEntity", DataServiceEntities.SASEntityExtensionClass, key);
}


export function createGenerateUrisInput(sasEntity: DataServiceEntities.ISASEntity): IDataServiceRequest {
  const query = sASQuery();
  return query.createDataServiceRequestForOperation('GenerateUris', true, DataServiceEntities.SASEntityExtensionClass, 'false', { bypassCache: 'get', returnEntity: 'DataServiceEntities.ISASEntity' }, { sasEntity: sasEntity });
}


export function generateUrisAsync(context: IContext, sasEntity: DataServiceEntities.ISASEntity): AsyncResult<DataServiceEntities.ISASEntity> {
  const request = createGenerateUrisInput(sasEntity);
  return callActionOrExecute<DataServiceEntities.ISASEntity>(request, context.callerContext);
}

export function createGetConfigInfoInput(): IDataServiceRequest {
  const query = sASQuery();
  return query.createDataServiceRequestForOperation('GetConfigInfo', false, DataServiceEntities.SASConfigEntityExtensionClass, 'false', { bypassCache: 'none', returnEntity: 'DataServiceEntities.ISASConfigEntity' }, {});
}


export function getConfigInfoAsync(context: IContext): AsyncResult<DataServiceEntities.ISASConfigEntity> {
  const request = createGetConfigInfoInput();
  return callActionOrExecute<DataServiceEntities.ISASConfigEntity>(request, context.callerContext);
}
